import {IStrapiEntity, StrapiUtils} from "services/strapi";
import {ListItemsTable, ListItemsTableProps} from "components/common";
import {RoutesResolver} from "routes";
import {IShipment, TableSettings} from "features/shipments";

interface Props extends Omit<ListItemsTableProps<
    IShipment & { id: number },
    void>,
    'settings' | 'data'> {

    data?: IStrapiEntity<IShipment>[]
}

export function ShipmentsListTable({data, ...rest}: Props){
    const routesResolver = new RoutesResolver()
    return (
        <ListItemsTable
            {...rest}
            data={StrapiUtils.flattenStrapiEntities(data)}
            settings={TableSettings({
                routesResolver,
            })}
        />
    )
}